package dk.smark.chat.network

import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

class FriendApiService(
    private val baseUrl: String = "https://dbapi.smark.dk",
    private val client: HttpClient = HttpClient {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
            })
        }
        install(HttpTimeout) {
            requestTimeoutMillis = 10_000
            connectTimeoutMillis = 10_000
        }
    }
) {

    /** GET /users/{userId}/friends */
    suspend fun getFriends(userId: Int): List<User> =
        client.get("$baseUrl/users/$userId/friends").body()

    /** POST /users/{userId}/friend-requests */
    suspend fun sendFriendRequest(userId: Int, toEmail: String): FriendRequest =
        client.post("$baseUrl/users/$userId/friend-requests") {
            contentType(ContentType.Application.Json)
            setBody(SendFriendRequestBody(toEmail))
        }.body()

    /** GET /users/{userId}/friend-requests/received */
    suspend fun getReceivedFriendRequests(userId: Int): List<FriendRequest> =
        client.get("$baseUrl/users/$userId/friend-requests/received").body()

    /** PATCH /friend-requests/{requestId}/accept */
    suspend fun acceptFriendRequest(requestId: Int): Unit =
        client.patch("$baseUrl/friend-requests/$requestId/accept").body()

    /** DELETE /friend-requests/{requestId} */
    suspend fun declineFriendRequest(requestId: Int): Unit =
        client.delete("$baseUrl/friend-requests/$requestId").body()

    /** POST /invites */
    suspend fun inviteContact(email: String, inviterName: String): Unit =
        client.post("$baseUrl/invites") {
            contentType(ContentType.Application.Json)
            setBody(InviteContactRequest(email, inviterName))
        }.body()
}
